import React from 'react';
import FollowCollegesButton from './follow-colleges-button';

const DiscoverCollegesButton = () => (
  <div className="discover-colleges-container" data-testid="discover-collleges-button">
    <FollowCollegesButton buttonName="discover-colleges" buttonText="Discover Colleges" />
  </div>
);

export default DiscoverCollegesButton;
